import(/* webpackMode: "eager" */ "/home/runner/work/riteshvijaykumar.github.io/riteshvijaykumar.github.io/src/app/not-found.tsx");
